import { connect } from 'react-redux';
import AdRule from '../../../components/sections/pluginSettings/AdRules/AdRule';
import { removeAdRule, updateAdRule } from '../../../actions';

const mapStateToProps = (state, props) => {
  return {
    data: state.adRules.data[props.index],
    isValid: state.adRules.isValid,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    removeAdRuleAction: index => {
      dispatch(removeAdRule(index));
    },
    updateState: data => {
      dispatch(updateAdRule(data));
    },
  };
};

const AdRuleRedux = connect(mapStateToProps, mapDispatchToProps)(AdRule);

export default AdRuleRedux;
